import { createApiSaga } from '../../sagaGenerator';
import { apiGet } from '../../../middleware/api';
import {
  GET_EARTHQUAKE_INFO_REQUEST,
  GET_EARTHQUAKE_INFO_SUCCESS,
  GET_EARTHQUAKE_INFO_FAILURE,
  GET_EARTHQUAKE_INFO_REFERENCES_REQUEST,
  GET_EARTHQUAKE_INFO_REFERENCES_SUCCESS,
  GET_EARTHQUAKE_INFO_REFERENCES_FAILURE,
} from './earthquakeInfoReducer';

const getEarthquakeInfoSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/earthquakes/${action.id}/info`, ...action }),
  requestType: GET_EARTHQUAKE_INFO_REQUEST,
  successType: GET_EARTHQUAKE_INFO_SUCCESS,
  failureType: GET_EARTHQUAKE_INFO_FAILURE,
});

const getEarthquakeReferencesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/earthquakes/${action.id}/references`, ...action }),
  requestType: GET_EARTHQUAKE_INFO_REFERENCES_REQUEST,
  successType: GET_EARTHQUAKE_INFO_REFERENCES_SUCCESS,
  failureType: GET_EARTHQUAKE_INFO_REFERENCES_FAILURE,
});

export const earthquakeInfoSagas = [
  getEarthquakeInfoSaga,
  getEarthquakeReferencesSaga,
];
